export var Routes = {
    HOMEPAGE: '/',
    CART: '/sepetim',
    DELIVERY_ADDRESS: '/teslimat-adresi',
    ADDITIONAL_PRODUCTS: '/ek-urunler',
    CARD_MESSAGE: '/kart-mesaji'
};
